/**
 * The game's wide view (PORT, not in the original): the original game is an 807x600 window (FWP.WINDOW_WIDTH /
 * WINDOW_HEIGHT). A screen of another shape shows that window whole, as tall as the screen, plus the margin around it
 * (Flash's showAll shows what lies beyond the stage's edges): every scene has content there (the port's extension art,
 * stretched backgrounds, more of the battle's world), up to these limits; beyond them there are letterbox bars.
 *
 * Shared by the client (src/main.ts: the host's limits), the game (its layouts and the battle camera read the shown
 * part from Stage.visibleRect) and the battle input's validation (a map click may lie in the margin: the widest view
 * any client can have, the same numbers on every device, so a recorded battle stays valid everywhere).
 */

/** The largest part of the game's window any screen shows, centred on it (stage px): up to ~22:9, and 1.19:1. */
export const WIDE_VIEW = Object.freeze({ width: 1467, height: 680 });

/** The margin beyond each side edge of the 807x600 window (stage px). */
export const WIDE_MARGIN_X = (WIDE_VIEW.width - 807) / 2;

/** The margin beyond the top and the bottom edge of the window (stage px). */
export const WIDE_MARGIN_Y = (WIDE_VIEW.height - 600) / 2;

/**
 * The narrowest part of the window's width a screen narrower than 807:600 may show (stage px): a 4:3 screen shows the
 * window as tall as the screen with 3.5 px of each side cut off, rather than thin bars above and below.
 */
export const WIDE_MIN_WIDTH = 800;
